import React from "react";
import { Box } from "@mui/material";
import { PaginationControls } from "../../../shared/components";
import { KanbanBoard } from "./kanban/KanbanBoard";

export const AllTasks: React.FC<{ taskData: any, handleStatusChange: (taskId: string, newStatus: string) => void; onEdit: (taskId: string) => void; pagination: { total: number; limit: number; page: number; }, changeRowsPerPage: (rowsPerPage: number) => void, changePage: (page: number) => void }> = ({ taskData, handleStatusChange, onEdit, pagination, changeRowsPerPage, changePage }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        overflow: 'hidden',
      }}
    >
      <Box flex={1} overflow="auto" p={2}>
        <KanbanBoard
          tasks={taskData}
          onStatusChange={handleStatusChange}
          onEdit={onEdit}
        />
      </Box>
      <Box flexShrink={1}>
        <PaginationControls
          total={pagination.total}
          rowsPerPage={pagination.limit}
          currentPage={pagination.page}
          handleRowsPerPage={changeRowsPerPage}
          handlePageChange={changePage}
        />
      </Box>
    </Box>
  );
};
